var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vx-card',{attrs:{"title":_vm.title}},[_c('h6',[_vm._v("\n        Bet : "+_vm._s(_vm.loading(_vm.currency(_vm.sumAmount)))+"\n      ")]),_c('br'),_c('h6',[_vm._v("\n        Win/Lose :\n        "),_c('span',{class:_vm.sumWinLose > 0
              ? 'text-success'
              : 'text-danger'},[_vm._v("\n          "+_vm._s(_vm.loading(_vm.currency(_vm.sumWinLose)))+"\n        ")])]),_c('br'),_c('h6',[_vm._v("\n        Rolling :\n        "+_vm._s(_vm.loading(_vm.currency(_vm.sumRolling)))+"\n      ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }